<template>
	<a-modal title="操作" style="top: 20px;" :width="900" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk"
	 @cancel="handleCancel">
		<a-form :form="form">

			<a-form-item style="display:none">
				<a-input v-decorator="['roleId']" />
			</a-form-item>

			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色名称">
				<a-input v-decorator="[
            'roleName',
            {
              rules: [{ required: true, message: '请输入角色名称' }]
            }
          ]"
				 placeholder="起一个名字" />
			</a-form-item>
			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="权限字符">
				<a-input v-decorator="['roleKey',{rules: [{ required: true, message: '请输入权限字符' }]}]" placeholder="权限字符" />
			</a-form-item>
			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="显示顺序">
				<a-input v-decorator="['roleSort',{rules: [{ required: true, message: '请输入顺序' }]}]" placeholder="显示顺序" />
			</a-form-item>
			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
				<a-select v-decorator="['status', {initialValue:'0',rules: [{ required: true, message: '请选择状态' }]}]">
					<a-select-option :value="'0'">正常</a-select-option>
					<a-select-option :value="'1'">禁用</a-select-option>
				</a-select>
			</a-form-item>
				<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色说明">
				    <a-input v-decorator="['roleExplain']" placeholder="请输入角色说明" />
			</a-form-item>
		

			<a-divider />
			<a-row>
				<a-col :span="12">
					<a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="拥有权限">
						<a-tree checkable v-model="checkedKeys" @check="onCheck" :treeData="permissions">
						</a-tree>
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="自定义审批权限">
						<a-tree checkable :autoExpandParent="autoExpandParent" v-if="deptTree2.length>0" v-model="checkedKeys2"
						 :treeData="deptTree2" @check="onCheck2">
						</a-tree>
					</a-form-item>
				</a-col>
			</a-row>
		</a-form>

	</a-modal>
</template>

<script>
	import {
		getPermissions,
		getRolePermIds,
		saveRole,
		list_role,
		getDeptList,
	} from '@/api/system'
	import pick from 'lodash.pick'

	export default {
		name: 'RoleModal',
		data() {
			return {
				labelCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 6
					}
				},
				wrapperCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 16
					}
				},
				labelCol2: {
					span:12
				},
				wrapperCol2: {
					span:5
				},
				visible: false,
				confirmLoading: false,
				mdl: {},
				form: this.$form.createForm(this),
				permissions: [],
				treeCheck: false,
				treeCheck2: false,
				pidSet: [],
				pidSet2: [],
				deptTree2: [],
				checkedKeys: [],
				checkedKeys2: [],
				halfCheckedKeys: [],
				halfCheckedKeys2: [],
				autoExpandParent: true,
			}
		},
		created() {
			this.loadPermissions()
			getDeptList().then(res => {
				const data = res.rows
				if (data.length > 0) {
					const pids = data.map(m => m.parentId)
					this.buildtree2(data, this.deptTree2, Math.min(...pids))
					const pidSet = new Set(pids.map(m => m + ''))
					this.pidSet2 = pidSet
				}
			})
		},
		methods: {
			buildtree2(list, arr, parentId) {
				list.forEach(item => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId + '',
							value: item.deptId + '',
							title: item.deptName,
							children: []
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			add() {
				this.form.resetFields()
				this.checkedKeys = []
				this.pidSet = []
				this.checkedKeys2 = []
				this.edit({})
			},
			edit(record) {
				if (record.roleId) {
					getRolePermIds(record.roleId).then(res => {
						const pidSet = new Set(res.map(m => m.parentId).filter(id => id > 0))
						this.pidSet = pidSet
						// 因为antd 树插件勾选父节点会导致所有子节点选中,所以过滤所有父节点
						this.checkedKeys = res.map(m => m.menuId).filter(id => !pidSet.has(id))
						console.log(this.pidSet,this.checkedKeys,res,222)
					})
				}
				if(record.roleDept){
					list_role(record.roleDept.split(';')).then(res => {
						this.checkedKeys2=res.data.map(m => m.deptId).filter(id => !this.pidSet2.has(id)).map(String)
						console.log(this.checkedKeys2)
					})
				}else{
					this.checkedKeys2=[]
				}
				this.mdl = Object.assign({}, record)
				// 如果没有check过，半选节点是拿不到的，只能通过预先设置的pidSet获取
				this.treeCheck = false
				this.treeCheck2 = false
				this.visible = true
				this.$nextTick(() => {
					this.form.setFieldsValue(pick(this.mdl, 'roleId', 'roleName', 'status', 'roleSort', 'roleKey', 'roleExplain'))
					// this.form.setFieldsValue(...record)
				})
			},
			close() {
				this.$emit('close')
				this.visible = false
			},
			onExpand(expandedKeys) {
				console.log('onExpand', expandedKeys)
				this.expandedKeys = expandedKeys
				this.autoExpandParent = false
			},
			onCheck(checkedKeys, info) {
				if (!this.treeCheck) this.treeCheck = true
				console.log('onCheck', info,checkedKeys)
				this.checkedKeys = checkedKeys
				this.halfCheckedKeys = info.halfCheckedKeys
			},
			onCheck2(checkedKeys, info) {
				if (!this.treeCheck2) this.treeCheck2 = true
				this.checkedKeys2 = checkedKeys
				this.halfCheckedKeys2 = info.halfCheckedKeys
			},
			onSelect(selectedKeys, info) {
				console.log('onSelect', info)
				this.selectedKeys = selectedKeys
			},
			loadPermissions() {
				getPermissions().then(res => {
					this.buildtree(res.rows, this.permissions, 0)
				})
			},
			buildtree(list, permissions, parentId) {
				list.forEach(item => {
					if (item.parentId === parentId) {
						var child = {
							key: item.menuId,
							title: item.menuName,
							children: []
						}
						this.buildtree(list, child.children, item.menuId)
						permissions.push(child)
					}
				})
			},
			handleOk(e) {
				const _this = this
				// 如果没有check过，半选节点是拿不到的，只能通过预先设置的pidSet获取
				const checkedAll = this.treeCheck ? _this.checkedKeys.concat(_this.halfCheckedKeys) : _this.checkedKeys.concat(
					Array.from(_this.pidSet))
				console.log(checkedAll)
				if (!checkedAll.length > 0) {
					_this.$message.warning('请至少选择一个权限')
					return
				}
				// 触发表单验证
				this.form.validateFields((err, values) => {
					console.log(this.$form.createForm(this), 'values+++++++++++++++++++++++')
					// 验证表单没错误
					if (!err) {
						values.menuIds = checkedAll
						console.log(values.menuIds,this.checkedKeys2,'=================================')
						values.roleDept = this.checkedKeys2.join(';')
						_this.confirmLoading = true
						console.log(Object.assign(values), 'Object.assign(values)+++++++++++++++++++++++')
						saveRole(Object.assign(values)).then(res => {
							if (res.code === 200) {
								_this.$message.success('保存成功')
								_this.$emit('ok')
								_this.visible = false
							} else {
								_this.$message.success(res.msg)
							}
						}).catch(() => {
							_this.$message.error('系统错误，请稍后再试')
						}).finally(() => {
							_this.confirmLoading = false
						})
					}
				})
			},
			handleCancel() {
				this.visible = false
			}

		}
	}
</script>

<style scoped>

</style>
